import { render, staticRenderFns } from "./ClientStakeholderInput.vue?vue&type=template&id=5f01ec5f"
import script from "./ClientStakeholderInput.vue?vue&type=script&lang=js"
export * from "./ClientStakeholderInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports